import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UtilitiesService } from '../utilities/utilities.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContentPassService {

  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };
  constructor(private http: HttpClient, private UTS: UtilitiesService) {}

	getAccountPasses(accountId: String){
		return this.http
			.get(
			`${environment.ECARE_URL}/getAccountPasses.service?accountId=${accountId}`,
			this.httpOptions
			);
	}
	changePassStatus(accountId: String, skuId: String, payload: any){
		return this.http
			.post(
			`${environment.ECARE_URL}/caramel/changePassStatus.service?accountId=${accountId}&skuId=${skuId}`, payload,
			this.httpOptions
			);
	}
	setCurrentPlan(currentPlan: any){
		localStorage.setItem('currentPlan', JSON.stringify(currentPlan));
	}
	getCurrentPlan(){
		return JSON.parse(localStorage.getItem('currentPlan')) || {};
	}
	setPaidPassesIcons(paidPassesIcons: any){
		localStorage.setItem('paidPassesIcons', JSON.stringify(paidPassesIcons));
	}
	getPaidPassesIcons(){
		return JSON.parse(localStorage.getItem('padiPassesIcons')) || [];
	}
	settotalSelectedPasses(totalSelectedPasses: any){
		localStorage.setItem('totalSelectedPasses', JSON.stringify(totalSelectedPasses));
	}
	gettotalSelectedPasses(){
		return JSON.parse(localStorage.getItem('totalSelectedPasses')) || [];
	}
	setSourceSku(sourceSku: any){
		localStorage.setItem('sourceSku', JSON.stringify(sourceSku));
	}
	getSourceSku(){
		return JSON.parse(localStorage.getItem('sourceSku')) || [];
	}
	setDestinationSku(destinationSku: any){
		localStorage.setItem('destinationSku', JSON.stringify(destinationSku));
	}
	getDestinationSku(){
		return JSON.parse(localStorage.getItem('destinationSku')) || [];
	}
	
}
